var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{attrs:{"show":""}},[_c('div',[_vm._v(_vm._s(_vm.$dt('global.route_deprecated', 'Route moved. Please contact administrator')))]),(_vm.newUrl)?_c('div',[_vm._v(_vm._s(_vm.$dt('global.new_route', 'New address:') + ' ' + _vm.newUrl))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }